import { useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Context, Types } from '../../store';
import { AsyncState } from '../../store/types';
import { useService } from '../../store/useService';
import { RECEIVE_PARTS } from './ReceivePartsService';

/**
 * The useReceiveParts hook provides data and business logic for the useReceiveParts component

 */
export const useReceiveParts = ({ model, onCompleted }: any) => {
  const { dispatch }: any = useContext(Context);
  const history = useHistory();
  const { useMutation } = useService();
  const { receiveType, referenceId }: any = useParams();
  const [receiveParts, { loading, error, called, data }] = useMutation(RECEIVE_PARTS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      const receiveExecutionUUId = data?.receiveMaterialAsync?.receiveExecutionUUId;
      history.push(`/receive/${receiveType}/${referenceId}`);
      dispatch({
        type: Types.receiveParts,
        payload: { ...model, status: AsyncState.IN_PROGRESS, receiveExecutionUUId },
      });
      onCompleted && onCompleted(data);
    },
  });

  return {
    receiveParts,
    called,
    loading,
    error,
    data,
  };
};

export default useReceiveParts;
